import React from 'react';
import { NumericFormat } from 'react-number-format';

const NumberFormatCustom = React.forwardRef((props, ref) => {
    const { onChange, readOnly, decimalScale, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            readOnly={readOnly}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: +values.value,
                    },
                });
            }}
            thousandSeparator
            decimalScale={decimalScale}
        />
    );
});

export default NumberFormatCustom;
